import type { Patient, TreatmentStatus } from '../types/admin';

const names: readonly { first: string; last: string }[] = [
  { first: 'Elena', last: 'Kowalski' },
  { first: 'Marco', last: 'Benedetti' },
  { first: 'Sofia', last: 'Andersson' },
  { first: 'Lukas', last: 'Müller' },
  { first: 'Amara', last: 'Okafor' },
  { first: 'Yuki', last: 'Tanaka' },
  { first: 'Nina', last: 'Petrova' },
  { first: 'Carlos', last: 'Rivera' },
  { first: 'Hanna', last: 'Lindström' },
  { first: 'David', last: 'Schmid' },
  { first: 'Leila', last: 'Hassan' },
  { first: 'Tomas', last: 'Novak' },
  { first: 'Aria', last: 'De Vries' },
  { first: 'Felix', last: 'Wagner' },
];

const statuses: TreatmentStatus[] = ['active', 'active', 'active', 'draft', 'completed', 'cancelled'];

function makeId(i: number): string {
  return `pat-${String(i + 1).padStart(4, '0')}`;
}

function makeDate(daysAgo: number): string {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString();
}

export const mockPatients: readonly Patient[] = names.map((n, i) => ({
  id: crypto.randomUUID?.() ?? `uuid-${i}`,
  user_id: `user-${i}`,
  first_name: n.first,
  last_name: n.last,
  birth_date: `${1975 + (i % 30)}-${String((i % 12) + 1).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
  gender: i % 3 === 0 ? 'male' : i % 3 === 1 ? 'female' : null,
  display_id: makeId(i),
  avatar_url: null,
  tooth_spacing_map_url: null,
  email: `${n.first.toLowerCase()}.${n.last.toLowerCase()}@example.com`,
  is_active: i !== 5,
  registration_pending: false,
  active_treatment_status: statuses[i % statuses.length] ?? null,
  created_at: makeDate(120 - i * 8),
  updated_at: makeDate(i * 2),
}));
